/**
 * Author: Paul Grejaldo
 * Date: 2018/10/17
 * Time: 1:01 PM
 */
import { sendRequest } from '../../../api';

export const
	APP_PROP_CHANGE = 'APP_PROP_CHANGE',

	appPropChange   = ( payload ) => {
		return { type : APP_PROP_CHANGE, payload };
	},

	apiRequest      = ( props = {} ) => {
		const { ep, options } = props;

		return sendRequest( ep, _.omit( props, ['ep', 'options'] ), 'POST', options || {} );
	};
